module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductBoxColorVariants":{"title":"Barvy"}},"de":{"ProductBoxColorVariants":{"title":"Farben"}},"sk":{"ProductBoxColorVariants":{"title":"Farby"}}}')
  delete Component.options._Ctor
}
